<template>
    <el-button
        :ref="fref"
        :icon="icon"
        :size="size"
        :plain="fplain"
        :round="round"
        :circle="circle"
        :type="typeStyle"
        :autofocus="false"
        :loading="fLoading"
        :disabled="btn_disabled"
        @click="handleClick(clickEvent)"
    >
        {{ fContent }}
    </el-button>
</template>

<script>
const dao = require("@/api/core/dao");
const utils = require("@/api/core/utils");
export default {
    name: "yes-button",
    props: {
        formCreateInject: {
            type: Object,
            required: true
        },
        content: {
            type: String
        },
        size: {
            type: String
        },
        typeStyle: {
            type: String
        },
        plain: {
            type: Boolean
        },
        round: {
            type: Boolean
        },
        circle: {
            type: Boolean
        },
        loading: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        icon: {
            type: String
        },
        dataSource: String,
        clickEvent: String,
        afterCreateScript: String,
        // 是否需要阻止重复点击
        preventClick: {
            type: Boolean,
            default: true
        },
        // 阻止重复点击时间[默认2000ms]
        preventTime: {
            type: Number,
            default: 2000
        },
        // 重复点击时, 是否弹出提示
        showPreventTip: {
            type: Boolean,
            default: false
        },
        // 重复点击提示内容
        preventClickTip: {
            type: String,
            default: "执行操作中, 请勿重复点击"
        }
    },
    data() {
        return {
            time: 0,
            fref: "",
            fvalue: "",
            fplain: this.plain,
            btn_disabled: false,
            uuid: utils.getUUID(),
            fLoading: this.loading,
            fContent: this.content,
            fDataSource: this.dataSource
        };
    },
    created() {
        this.btn_disabled = this.disabled;
        this.fref = `yes-tab-${this.uuid}`;
    },
    async mounted() {
        this.afterCreate();
    },
    methods: {
        setColor(color) {
            /** 
                入参的几种形式
                color = #000;
                color = "red";
                color = rgb(0,0,0);
                color = rgba(0,0,0,0.8)
             */
            const className = `cls-${this.uuid}`;
            const existingStyle = document.querySelector(`style.${className}`);
            if (existingStyle) {
                existingStyle.remove();
            }
            const style = document.createElement("style");
            // 给 style 添加 class 名称，方便查找和删除
            style.className = className;
            style.innerHTML = `
              .${className} {
                ${color}  
              }
            `;
            document.head.appendChild(style);
            // 5. 添加类到目标元素
            this.$refs[this.fref].$el.classList.add(className);
        },
        setCircle(circle) {
            this.circle = circle;
        },
        setContent(content) {
            this.fContent = content;
        },
        getContent() {
            return this.fContent;
        },
        setDisabled(value) {
            this.btn_disabled = value;
        },
        setPlain(value) {
            this.fplain = value;
        },
        setLoading(value) {
            this.fLoading = value;
        },
        getValue() {
            return this.fvalue;
        },
        // 修改组件的值
        setValue(val) {
            this.fvalue = val;
        },
        loadSourceData() {
            const req = utils.getSourceData(this.fDataSource);
            if (req) {
                this.fvalue = req;
            }
        },
        isDarg() {
            if (this.$parent.$options._componentTag == "dragTool") {
                return true;
            }
        },
        async handleClick() {
            if (!this.isDarg()) {
                if (this.handlePrevent()) return;
                const clickEvent = window.AsyncFunction("vm", "api", "dao", "fApi", "utils", this.clickEvent);
                await clickEvent(this, this.formCreateInject.api, dao, this.formCreateInject, utils);
            }
        },
        async afterCreate() {
            const afterCreateEvent = window.AsyncFunction("vm", "api", "dao", "fApi", "utils", this.afterCreateScript);
            await afterCreateEvent(this, this.formCreateInject.api, dao, this.formCreateInject, utils);
        },
        /**
         * 阻止重复点击
         * T: 阻止 F: 不阻止
         */
        handlePrevent() {
            if (!this.preventClick) return false;
            const nowTime = Date.now();
            const intervalTime = nowTime - this.time;
            // 如果点击间隔小于 this.preventTime 则不执行后续操作
            let result = false;
            if (intervalTime < this.preventTime) {
                // 是否显示 提示信息
                if (this.showPreventTip) {
                    utils.messageWarning(this.preventClickTip);
                }
                result = true;
            }
            // 更新为当前时间戳
            this.time = nowTime;
            return result;
        }
    }
};
</script>

<style>
.el-button--primary {
    color: #FFF;
    background-color: #2A61F1;
    border-color: #2A61F1;
}
.el-button--primary.is-disabled{
    color: #FFF;
    background-color: #9fb9ff;
    border-color: #9fb9ff;
}
.el-button--primary:focus, .el-button--primary:hover {
    background: #2A61F1;
    border-color: #2A61F1;
    color: #FFF;
}
</style>
